import React from "react";
import "./App.css";
import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import BaseLayout from "./layouts/BaseLayout";

//Authentications
import Login from "./pages/regular/user/authentication/Login";
import ForgotPassword from "./pages/regular/user/authentication/ForgotPassword";
import ChangePassword from "./pages/regular/user/authentication/ChangePassword";
import HomePage from "./pages/regular/HomePage";
import ChargeHomePage from "./pages/regular/charges/ChargesHomePage";
import ChargeCreate from "./pages/regular/charges/ChargeCreate";
import ChargeEdit from "./pages/regular/charges/ChargeEdit";
import ChargeDetail from "./pages/regular/charges/ChargeDetail";
import DepartmentCreate from "./pages/regular/departments/DepartmentCreate";
import DepartmentEdit from "./pages/regular/departments/DepartmentsEdit";
import DepartmentDetail from "./pages/regular/departments/DepartmentsDetail";
import DepartmentsHomePage from "./pages/regular/departments/DepartmentsHomePage";
import CountryDetail from "./pages/regular/country/CountryDetail";
import CountryEdit from "./pages/regular/country/CountryEdit";
import CountryCreate from "./pages/regular/country/CountryCreate";
import CountryHomePage from "./pages/regular/country/CountryHomePage";
import OrganizationHomePage from "./pages/regular/organization/OrganizationHomePage";
import OrganizationCreate from "./pages/regular/organization/OrganizationCreate";
import OrganizationEdit from "./pages/regular/organization/OrganizationEdit";
import OrganizationDetail from "./pages/regular/organization/OrganizationDetail";
import DocumentTypeHomePage from "./pages/regular/documenttype/DocumenttypeHomePage";
import DocumenttypeCreate from "./pages/regular/documenttype/DocumenttypeCreate";
import DocumentTypeEdit from "./pages/regular/documenttype/DocumenttypeEdit";
import DocumentTypeDetail from "./pages/regular/documenttype/DocumenttypeDetail";
import PermissionsHomePage from "./pages/regular/permissions/PermissionsHomePage";
import PermissionsCreate from "./pages/regular/permissions/PermissionsCreate";
import PermissionsEdit from "./pages/regular/permissions/PermissionsEdit";
import PermissionsDetail from "./pages/regular/permissions/PermissionsDetail";
import UsersHomePage from "./pages/regular/user/UsersHomePage";
import UsersEdit from "./pages/regular/user/UsersEdit";
import UsersCreate from "./pages/regular/user/UsersCreate";
import UsersDetail from "./pages/regular/user/UsersDetail";
import UserRoles from "./pages/regular/user/UserRoles";
import StatusHomePage from "./pages/regular/status/StatusHomePage";
import StatusCreate from "./pages/regular/status/StatusCreate";
import StatusEdit from "./pages/regular/status/StatusEdit";
import StatusDetail from "./pages/regular/status/StatusDetail";
import SignHomePage from "./pages/regular/sign/SignHomePage";
import SignUsers from "./pages/regular/sign/SignUsers";
import SignFiles from "./pages/regular/sign/SignFiles";
import SignForms from "./components/Forms/SignForms";
import SignDetail from "./pages/regular/sign/SignDetail";
import ErrorPage from "./pages/ErrorPage";
import Waitingroom from "./pages/WaitingRoom";
import ExternalSignHomepage from "./pages/regular/externalSigns/ExternalSignHomePage";
import ExternalSignUsers from "./pages/regular/externalSigns/ExternalSignUsers";
import ExternalSignFiles from "./pages/regular/externalSigns/ExternalSignFiles";
import ExternalSignForm from "./components/Forms/ExternalSignForms";
import UserFiles from "./pages/regular/user/UserFiles";

function App() {
  const routeDefinitions = createRoutesFromElements(
    <Route>
      <Route path="*" element={<ErrorPage />} />
      <Route path="/waitingroom/:pk" element={<Waitingroom />} />,
      <Route
        path="/"
        element={<BaseLayout />}
        children={[
          <Route key="Home" path="/home" element={<HomePage />} />,
          <Route key="Login" path="/login" element={<Login />} />,
          
          <Route
            key="ForgotPassword"
            path="/forgotpassword/"
            element={<ForgotPassword />}
          />,

          <Route
            key="ChangePassword"
            path="/changepassword/:userId/:token"
            element={<ChangePassword />}
          />,
          <Route
            key="ChangePassword"
            path="/auth/changepassword/:userId"
            element={<ChangePassword />}
          />,
          <Route key="Charges" path="/charges" element={<ChargeHomePage />} />,
          <Route
            key="ChargesCreate"
            path="/charges/create"
            element={<ChargeCreate />}
          />,
          <Route
            key="ChargesEdit"
            path="/charges/edit/:chargeId"
            element={<ChargeEdit />}
          />,
          <Route
            key="ChargesDetail"
            path="/charges/detail/:chargeId"
            element={<ChargeDetail />}
          />,
          <Route
            key="Departments"
            path="/departments"
            element={<DepartmentsHomePage />}
          />,
          <Route
            key="DepartmentCreate"
            path="/departments/create"
            element={<DepartmentCreate />}
          />,
          <Route
            key="DepartmentEdit"
            path="/departments/edit/:departmentId"
            element={<DepartmentEdit />}
          />,
          <Route
            key="DepartmentDetail"
            path="/departments/detail/:departmentId"
            element={<DepartmentDetail />}
          />,
          <Route key="Country" path="/country" element={<CountryHomePage />} />,
          <Route
            key="CountryCreate"
            path="/country/create"
            element={<CountryCreate />}
          />,
          <Route
            key="CountryEdit"
            path="/country/edit/:countryId"
            element={<CountryEdit />}
          />,
          <Route
            key="CountryDetail"
            path="/country/detail/:countryId"
            element={<CountryDetail />}
          />,
          <Route
            key="Organization"
            path="/organization"
            element={<OrganizationHomePage />}
          />,
          <Route
            key="OrganizationCreate"
            path="/organization/create"
            element={<OrganizationCreate />}
          />,
          <Route
            key="OrganizationEdit"
            path="/organization/edit/:organizationId"
            element={<OrganizationEdit />}
          />,
          <Route
            key="OrganizationDetail"
            path="/organization/detail/:organizationId"
            element={<OrganizationDetail />}
          />,
          <Route
            key="DocumentType"
            path="/documenttype"
            element={<DocumentTypeHomePage />}
          />,
          <Route
            key="DocumentTypeCreate"
            path="/documenttype/create"
            element={<DocumenttypeCreate />}
          />,
          <Route
            key="DocumentTypeEdit"
            path="/documenttype/edit/:documenttypeId"
            element={<DocumentTypeEdit />}
          />,
          <Route
            key="DocumentTypeDetail"
            path="/documenttype/detail/:documenttypeId"
            element={<DocumentTypeDetail />}
          />,
          <Route
            key="Permissions"
            path="/permissions"
            element={<PermissionsHomePage />}
          />,
          <Route
            key="PermissionsCreate"
            path="/permissions/create"
            element={<PermissionsCreate />}
          />,
          <Route
            key="PermissionsEdit"
            path="/permissions/edit/:permissionId"
            element={<PermissionsEdit />}
          />,
          <Route
            key="PermissionsDetail"
            path="/permissions/detail/:permissionId"
            element={<PermissionsDetail />}
          />,
          <Route key="Users" path="/users" element={<UsersHomePage />} />,
          <Route
            key="UsersCreate"
            path="/users/create"
            element={<UsersCreate />}
          />,
          <Route
            key="UsersEdit"
            path="/users/edit/:userId"
            element={<UsersEdit />}
          />,
          <Route
            key="UsersDetail"
            path="/users/detail/:userId"
            element={<UsersDetail />}
          />,
          <Route
            key="AssignRoles"
            path="/users/roles/:userId"
            element={<UserRoles />}
          />,
          <Route key="Status" path="/status" element={<StatusHomePage />} />,
          <Route
            key="Status"
            path="/status/create"
            element={<StatusCreate />}
          />,
          <Route
            key="Status"
            path="/status/edit/:statusId"
            element={<StatusEdit />}
          />,
          <Route
            key="Status"
            path="/status/detail/:statusId"
            element={<StatusDetail />}
          />,
          <Route key="Sign" path="/sign" element={<SignHomePage />} />,
          <Route key="Sign" path="/sign/users" element={<SignUsers />} />,
          <Route
            key="Sign"
            path="/sign/:userId/request/create"
            element={<SignForms />}
          />,
          <Route
            key="Sign"
            path="/sign/:userId/request/files"
            element={<SignFiles />}
          />,
          <Route
            key="Sign"
            path="/sign/detail/:signpk"
            element={<SignDetail />}
          />,
          <Route
            key="ExternalSign"
            path="/external-signs"
            element={<ExternalSignHomepage />}
          />,
          <Route
            key="ExternalSign"
            path="/external-signs/users"
            element={<ExternalSignUsers />}
          />,
          <Route
            key="ExternalSign"
            path="/external-signs/:userId/request/files"
            element={<ExternalSignFiles />}
          />,
          <Route
            key="ExternalSign"
            path="/external-signs/:userId/request/create"
            element={<ExternalSignForm />}
          />,
          <Route
            key="UserFiles"
            path="/upload-users"
            element={<UserFiles />}
          />
        ]}
      />
    </Route>
  );
  const router = createBrowserRouter(routeDefinitions);

  return <RouterProvider router={router} />;
}
export default App;
